import { useEffect, useRef, useState } from 'react';

export default function ActionsMenu({ label = 'More actions', items = [], align = 'right', compact = false, onOpenChange }) {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    const updateOpen = (next) => {
        setIsOpen(next);
        onOpenChange?.(next);
    };

    useEffect(() => {
        if (!isOpen) return;

        const handlePointerDown = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                updateOpen(false);
            }
        };

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                updateOpen(false);
            }
        };

        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [isOpen]);

    return (
        <div
            ref={menuRef}
            className={`actions-menu${compact ? ' compact' : ''}`}
            onClick={(event) => event.stopPropagation()}
        >
            <button
                type="button"
                className="actions-menu-trigger"
                aria-label={label}
                aria-haspopup="menu"
                aria-expanded={isOpen}
                title={label}
                onClick={() => updateOpen(!isOpen)}
            >
                <i className="fa-solid fa-ellipsis"></i>
            </button>

            {isOpen && (
                <div
                    className={`actions-menu-popover ${align === 'left' ? 'align-left' : ''}`}
                    role="menu"
                >
                    {items.map((item) => (
                        <button
                            key={item.label}
                            type="button"
                            className={`actions-menu-item ${item.danger ? 'danger' : ''}`}
                            role="menuitem"
                            disabled={item.disabled}
                            onClick={(event) => {
                                event.stopPropagation();
                                item.onSelect?.(event);
                                updateOpen(false);
                            }}
                        >
                            {item.icon && <i className={item.icon}></i>}
                            <span>{item.label}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
